import { Button, Flex, Popconfirm } from "antd";
import { FC, useMemo } from "react";
import { CheckoutOrder, OrderType } from "tm-shared/types";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText } from "@/shared/ui/Typography";

interface CheckoutCardLabelProps {
    checkout: CheckoutOrder;
    orderTypeVocabulary: Record<OrderType, string>;
    submitting: boolean;
    removing: boolean;
    moving: boolean;
    moveDisable: boolean;
    onDelete: () => void;
    onMove: () => void;
}

export const CheckoutCardLabel: FC<CheckoutCardLabelProps> = ({
    checkout,
    orderTypeVocabulary,
    submitting,
    removing,
    moving,
    moveDisable,
    onDelete,
    onMove,
}) => {
    const { marketName, paymentForm, orderType, amount, products } = checkout;

    const productCount = useMemo(
        () =>
            Object.values(products ?? {}).reduce(
                (sum, p) => sum + (p.count ?? 0),
                0,
            ),
        [products],
    );

    return (
        <Flex vertical gap={"small"}>
            <PrimaryText type="secondary">{marketName}</PrimaryText>

            <Flex wrap="wrap" gap={8}>
                <PrimaryText>
                    <b>Тип заявки:</b> {orderTypeVocabulary[orderType]}
                </PrimaryText>

                <PrimaryText>
                    <b>Форма оплати:</b> {paymentForm}
                </PrimaryText>

                <PrimaryText>
                    <b>Товарів:</b> {productCount} шт.
                </PrimaryText>

                <PrimaryText>
                    <b>Сума:</b> {formatUAHStandard(amount)}
                </PrimaryText>
            </Flex>

            <Flex gap={8} wrap="wrap" onClick={(e) => e.stopPropagation()}>
                <Popconfirm
                    onConfirm={onDelete}
                    title="Ви впевнені?"
                    description="Замовлення буде видалено без можливості відновлення"
                    okText="Видалити"
                    cancelText="Скасувати"
                    okButtonProps={{ style: { width: "auto" } }}
                    cancelButtonProps={{ style: { width: "auto" } }}
                >
                    <Button danger loading={removing} disabled={submitting}>
                        Видалити
                    </Button>
                </Popconfirm>

                <Popconfirm
                    title="Ви впевнені?"
                    description="Замовлення буде перенесено на сьогодні"
                    onConfirm={onMove}
                    disabled={moveDisable}
                    okText="Перенести"
                    cancelText="Скасувати"
                    okButtonProps={{ style: { width: "auto" } }}
                    cancelButtonProps={{ style: { width: "auto" } }}
                >
                    <Button
                        type="primary"
                        loading={moving}
                        disabled={moveDisable}
                    >
                        Перенести
                    </Button>
                </Popconfirm>
            </Flex>
        </Flex>
    );
};
